<div class="kyb-added-parties">

  <!-- A party that is itself a trust or partnership has no officers of its own, so instead of a
       signers table it gets its own trustee/partner entry, rendered inside that row's own card; the
       parties entered there are the entities whose KYB runs supply the signers. Which one to render
       comes from the type the row's ABN/ACN lookup returned. -->
  <ng-template #nestedPartySection let-partyRow>
    @if (nestedPartyForRow(parentEntity, partyRow); as nestedParty) {
      @if (nestedControlFor(nestedParty); as nestedPartyControl) {
        <div class="kyb-nested-party">
          <div class="kyb-nested-party-heading">
            {{ kybSectionHeading(effectiveEntityType(nestedParty), false, nestedParty.entityName) }}
          </div>
          <message-box type="warn">{{ kybSectionWarning(effectiveEntityType(nestedParty)) }}</message-box>
          @if (effectiveEntityType(nestedParty) === 'trust') {
            <trustee
              [formControl]="nestedPartyControl"
              [businessNumberSearchFn]="businessNumberSearchFn"
              [showAssetsAndLiabilities]="showAssetsAndLiabilities"
              [kybMode]="true"
              [signerEntityFor]="signerEntityLookupFor(nestedParty)"
              [guarantorLockedStakeholderIds]="guarantorLockedStakeholderIds"
              [mark]="markObservable"
              (events)="onPartyEvent(nestedParty, 'trustee', $event)"
              (personRoleChange)="personRoleChange.emit($event)"
              (personSelectedChange)="personSelectedChange.emit($event)"
              (signerResolved)="resolved.emit($event)"
              (signerRetry)="reload()"
              (manualKybEntry)="onManualKybEntry($event)"
              (manualPeopleChange)="onManualPeople($event)"
              (manualValidityChange)="onManualValidity($event)">
            </trustee>
          } @else {
            <partner
              [formControl]="nestedPartyControl"
              [businessNumberSearchFn]="businessNumberSearchFn"
              [showAssetsAndLiabilities]="showAssetsAndLiabilities"
              [kybMode]="true"
              [signerEntityFor]="signerEntityLookupFor(nestedParty)"
              [guarantorLockedStakeholderIds]="guarantorLockedStakeholderIds"
              [mark]="markObservable"
              (events)="onPartyEvent(nestedParty, 'partner', $event)"
              (personRoleChange)="personRoleChange.emit($event)"
              (personSelectedChange)="personSelectedChange.emit($event)"
              (signerResolved)="resolved.emit($event)"
              (signerRetry)="reload()"
              (manualKybEntry)="onManualKybEntry($event)"
              (manualPeopleChange)="onManualPeople($event)"
              (manualValidityChange)="onManualValidity($event)">
            </partner>
          }
        </div>
      }
    }
  </ng-template>

  @if (kybSectionWarning(entityType); as warning) {
    <message-box type="warn">{{ warning }}</message-box>
  }

  @for (error of integrityErrors; track error) {
    <message-box type="danger">{{ error }}</message-box>
  }

  <div class="kyb-add-party">
    @if (entityType === 'trust') {
      <trustee
        [formControl]="partyControl"
        [businessNumberSearchFn]="businessNumberSearchFn"
        [showAssetsAndLiabilities]="showAssetsAndLiabilities"
        [kybMode]="true"
        [signerEntityFor]="signerEntityLookupFor(parentEntity)"
        [nestedPartyTemplate]="nestedPartySection"
        [guarantorLockedStakeholderIds]="guarantorLockedStakeholderIds"
        [mark]="markObservable"
        (events)="onPartyEvent(parentEntity, 'trustee', $event)"
        (personRoleChange)="personRoleChange.emit($event)"
        (personSelectedChange)="personSelectedChange.emit($event)"
        (signerResolved)="resolved.emit($event)"
        (signerRetry)="reload()"
        (manualKybEntry)="onManualKybEntry($event)"
        (manualPeopleChange)="onManualPeople($event)"
        (manualValidityChange)="onManualValidity($event)">
      </trustee>
    } @else {
      <partner
        [formControl]="partyControl"
        [businessNumberSearchFn]="businessNumberSearchFn"
        [showAssetsAndLiabilities]="showAssetsAndLiabilities"
        [kybMode]="true"
        [signerEntityFor]="signerEntityLookupFor(parentEntity)"
        [nestedPartyTemplate]="nestedPartySection"
        [guarantorLockedStakeholderIds]="guarantorLockedStakeholderIds"
        [mark]="markObservable"
        (events)="onPartyEvent(parentEntity, 'partner', $event)"
        (personRoleChange)="personRoleChange.emit($event)"
        (personSelectedChange)="personSelectedChange.emit($event)"
        (signerResolved)="resolved.emit($event)"
        (signerRetry)="reload()"
        (manualKybEntry)="onManualKybEntry($event)"
        (manualPeopleChange)="onManualPeople($event)"
        (manualValidityChange)="onManualValidity($event)">
      </partner>
    }
  </div>

</div>
